import { TextField } from '@mui/material';
import type { NewCustomer } from '@weft/types';
import { CountriesDropDown } from 'apps/app/src/components/design/dropdowns/CountriesDropDown';
import { vyFormRegister } from 'apps/app/src/utils/react-hook-forms-utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { CustomerViewPropertiesBlock } from '../../CustomerInfoViewEditPage/customer-info-view-edit-components/CustomerViewPropertiesBlock';

export const CreateCustomerAddressBlock: React.FC = () =>{
  const { register, getValues } = useFormContext<NewCustomer>();

  const registerCity = vyFormRegister(register, 'address.city');
  const registerAddressText = vyFormRegister(register, 'address.addressText');
  const registerPostalCode = vyFormRegister(register, 'address.postalCode');

  return (
    <CustomerViewPropertiesBlock
      titleClassName='text-xl text-black font-medium'
      title='Address'
    >
      <div className="group flex w-1/2 flex-col pr-6">
        <CountriesDropDown
          defaultSelectedCountry={getValues('address.country')}
        />
      </div>
      <div className="group flex w-1/2 flex-col pr-6">
        <TextField
          label="City"
          placeholder="Text here"
          {...registerCity}
        />
      </div>
     
      <div className="group mt-4 flex w-1/2 flex-col pr-6">
        <TextField
          label="Address"
          placeholder="Text here"
          {...registerAddressText}
        />
      </div>
      <div className="group mt-4 flex w-1/2 flex-col pr-6">
        <TextField
          label="Postal Code"
          placeholder="Text here"
          {...registerPostalCode}
        />
      </div>
    </CustomerViewPropertiesBlock>
  );
};